<template>
  <div class="tekmodal">
    <!-- MODAL HEADER -->
    <div class="modalheader">
      <div class="headerleft">
        <div class="ico">
          <img src="../../assets/sidebar/opdrachten-ico.svg" alt />
        </div>
        <h4 class="header">Nieuwe Opdracht</h4>
      </div>
      <div class="header-buttons">
        <div class="close-btn" @click="closemodal">
          <img src="../../assets/close-btn.png" alt class="close-x" />
        </div>
      </div>
    </div>

    <!-- SAVE CHANGES sectie -->
    <div
      class="savesection"
      v-if="isOpdrachtVolledig == true"
      @click="saveChanges()"
    >
      <span>Voeg deze opdracht toe</span>
    </div>

    <!-- MODAL HEADER sectie -->
    <div class="section blue">
      <input
        v-model="opdracht.bedrijfsnaam"
        type="text"
        class="titeltekst tekstveld blue"
        placeholder="Bedrijfsnaam"
      />
      <div class="threecolumnsholder">
        <div>
          <span
            >CDT.{{ opdarchtNummerJaarDynamisch }}.{{
              opdarchtNummerMaandDynamisch
            }}.{{ hoogsteOpdrachtnummer + 1 }}</span
          >
          <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht.voornaam"
            placeholder="voornaam contact"
          />
          <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht.achternaam"
            placeholder="achternaam contact"
          />
        </div>
        <div>
          <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht.email"
            placeholder="email-adres"
          />
          <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht.telefoonnummer"
            placeholder="telefoonnummer"
          />
        </div>
      </div>
      <div class="threecolumnsholder">
        <div>
          <!-- tekenprogramma -->
          <select
            v-model="opdracht.tekenprogramma"
            class="tekstveld correctSelect"
          >
            <option value="">Tekenprogramma</option>
            <option value="Geen voorkeur">Geen voorkeur</option>
            <option value="AutoCAD">AutoCAD</option>
            <option value="Autodesk Revit">Autodesk Revit</option>
            <option value="SolidWorks">SolidWorks</option>
            <option value="BricsCAD">BricsCAD</option>
            <option value="Autodesk Inventor">Autodesk Inventor</option>
            <option value="Solid Edge">Solid Edge</option>
            <option value="Vectorworks">Vectorworks</option>
            <option value="Rhinoceros">Rhinoceros</option>
            <option value="MicroStation">MicroStation</option>
          </select>

          <!-- type opdracht -->
          <select
            v-model="opdracht.typeopdracht"
            class="tekstveld correctSelect"
          >
            <option value="">Type opdracht</option>
            <option value="Opdracht">Opdracht</option>
            <option value="Intern">Intern</option>
            <option value="Ondersteuning">Ondersteuning</option>
            <option value="Interne ondersteuning">Interne ondersteuning</option>
          </select>
        </div>
        <div>
          <!-- werkplek -->
          <select v-model="opdracht.werkplek" class="tekstveld correctSelect">
            <option value="">Werkplek</option>
            <option value="Interne werkplek bij bedrijf"
              >Interne werkplek bij bedrijf</option
            >
            <option value="Eigen werkplek tekenaar"
              >Eigen werkplek tekenaar</option
            >
            <option value="Gecombineerd">Gecombineerd</option>
            <option value="Geen voorkeur">Geen voorkeur</option>
          </select>
          <span>{{ opdracht.aanvraagdatum }}</span>
        </div>
      </div>
      <div style="padding-top:20px;">
        <div class="discholder" style="padding-top:10px;padding-bottom:0px;">
          <span>Selecteer discipline v.d. opdracht</span>
          <Multiselect v-model="opdracht.disciplines" :options="options" />
        </div>
      </div>
      <div class="vertical">
        <div style="padding-top:40px;">
          <span class="titeltekst">Omschrijving</span>

          <div class="discholder" style="padding-top:10px;">
            <textarea
              class="aantekening blue"
              v-model="opdracht.omschrijving"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../store";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";

export default {
  name: "TekModal",
  components: { Multiselect },

  data() {
    return {
      opdracht: {
        voornaam: "",
        achternaam: "",
        email: "",
        tekenprogramma: "",
        telefoonnummer: "",
        werkplek: "",
        typeopdracht: "",
        bedrijfsnaam: "",
        disciplines: "Bouwkunde",
        omschrijving: "",
        aanvraagdatum: ""
      },
      options: [
        "Bouwkunde",
        "Werktuigbouwkunde",
        "Installatietechniek",
        "Elektrotechniek",
        "Brandpreventie",
        "Huisvesting",
        "Plattegronden",
        "Concepten - 3D Print",
        "Nen2580",
        "Sem"
      ]
    };
  },
  computed: {
    ...mapGetters(["allOpdrachten"]),

    opdarchtNummerJaarDynamisch() {
      return new Date().getFullYear();
    },
    opdarchtNummerMaandDynamisch() {
      const currentMonth = new Date().getMonth() + 1; //Hij begint met tellen bij 0! => dus + 1
      if (currentMonth > 9) return currentMonth;
      return "0" + currentMonth;
    },
    hoogsteOpdrachtnummer() {
      const maxId = this.allOpdrachten.reduce(
        (max, character) =>
          character.opdrachtnummer > max ? character.opdrachtnummer : max,
        this.allOpdrachten[0].opdrachtnummer
      );
      return maxId;
    },

    isOpdrachtVolledig() {
      const opdr = this.opdracht;
      if (
        opdr.voornaam != "" &&
        opdr.achternaam != "" &&
        opdr.email != "" &&
        opdr.tekenprogramma != "" &&
        opdr.telefoonnummer != "" &&
        opdr.werkplek != "" &&
        opdr.typeopdracht != "" &&
        opdr.bedrijfsnaam != "" &&
        opdr.disciplines != "" &&
        opdr.bedrijfsnaam != "" &&
        opdr.omschrijving != ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    saveChanges() {
      const opdrachtInfo = {
        ...this.opdracht,
        opdrachtnummer: this.hoogsteOpdrachtnummer + 1,
        opdrachtnummerjaar: this.opdarchtNummerJaarDynamisch,
        opdrachtnummermaand: this.opdarchtNummerMaandDynamisch
      };
      if (confirm("Deze opdracht toevoegen aan CAD-opdracht.com?")) {
        store
          .dispatch("addOpdrToDB", opdrachtInfo)
          .then(this.$emit("close-Modal"));
      }
    },

    closemodal() {
      if (
        confirm("Deze opdracht wordt niet opgeslagen. Zeker weten afsluiten?")
      ) {
        this.$emit("close-Modal");
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
@media screen and (max-width: 663px) {
  .tekmodal {
    z-index: 2;
    position: fixed;
    overflow-y: scroll;
    left: auto;
    top: 0%;
    right: 0%;
    bottom: 0%;
    width: 100%;
    background-color: #fff;
    box-shadow: -20px 0 50px 0 rgba(0, 0, 0, 0.11);
    padding-bottom: 100px;
  }
}

.tingting {
  position: absolute;
  right: 40px;
}

.opdracht-bedrijfsnaam {
  white-space: nowrap;
}

.annuleersection {
  padding: 20px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e4ecfa;
  cursor: pointer;
}
.annuleersection:hover {
  background-color: #e3170a87;
}

.discipline-orange {
  background-color: #ff9323;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 13px;
  color: white;
  border: 2px solid white;
}

.herobarting {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

#cars {
  cursor: pointer;
  font-weight: 500;
  border: none;
  -webkit-appearance: none;
  background: none;
  color: #fff;
  font-size: 14px;
  /* width: inherit; */
  font-family: poppins;
  text-align: center;
}

.blue {
  background-color: #e4ecfa;
  /* color: #fff; */
  position: sticky !important;
  top: 70px;
  z-index: 1;
}

.blue.tekstveld {
  background: none;
}

/* .tekstveld.blue:hover {
        background-color: #1b4d8d;
    }
    .tekstveld.blue:focus {
        background-color: #1b4d8d;
    } */

.header {
  color: #fff;
  font-weight: 600;
  padding-right: 30px;
  font-size: 18px;
}
.headerleft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ico {
  background-color: #ff9326;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  padding: 4px;
  margin-right: 10px;
}

.header-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.deletebutton {
  background-color: #ff9326;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  cursor: pointer;
  margin-right: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 1px;
}
.correctSelect {
  cursor: pointer;
  font-weight: 500;
  border: none;
  -webkit-appearance: none;
  background: none;
  color: #000;
  font-size: 14px;
  /* width: inherit; */
  font-family: poppins;
  text-align: center;
}

.close-btn {
  width: 24px;
  height: 24px;
  display: flex;
  cursor: pointer;
  transition: 0.3s;
}
.close-btn:hover {
  transform: scale(1.2);
}

.delete-image {
  height: 16px;
}

.savesection {
  background-color: #ff9326;
  color: #fff;
  display: flex;
  width: 100%;
  max-width: 520px;
  padding: 24px;
  justify-content: center;
  cursor: pointer;
  font-weight: 600;
  position: fixed;
  bottom: 0;
  z-index: 1;
}

.opdracht {
  padding: 10px 0px;
  border-bottom: 1px solid #e4ecfa;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.opdracht:hover {
  background-color: #e4ecfa;
}

.tekmodal {
  z-index: 4;
  position: fixed;
  overflow-y: scroll;
  left: auto;
  max-width: 520px;
  top: 0%;
  right: 0%;
  bottom: 0%;
  min-width: 520px;
  background-color: #fff;
  box-shadow: -20px 0 50px 0 rgba(0, 0, 0, 0.11);
}
.modalheader {
  display: flex;
  height: 70px;
  padding: 0 25px;
  justify-content: space-between;
  align-items: center;
  background-color: #1b4d8d;
  color: white;
  font-size: 16px;
  font-weight: 600;
  position: sticky;
  top: 0px;
  z-index: 5;
}

.section {
  padding: 40px;
  position: relative;
  border-bottom: 1px solid #e4ecfa;
}

.section2 {
  padding: 40px;
  position: relative;
  padding-bottom: 300px;
}

.titeltekst {
  font-weight: 600;
  font-size: 20px !important;
}

.threecolumnsholder {
  display: flex;
  justify-content: space-between;
  align-items: top;
  width: 100%;
}

.threecolumnsholder div {
  width: 100%;
  padding-top: 15px;
  font-size: 15px;
  display: flex;
  flex-direction: column;
}

.vertical {
  display: flex;
  flex-direction: column;
}

.discipline {
  background-color: #e4ecfa;
  border-radius: 100px;
  padding: 5px 10px;
  margin-bottom: 15px;
  display: inline-block;
  /* display: flex;
        align-items: center;
        justify-content: center; */
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-right: 7px;
  /* border: 2px solid white; */
}

.tekstveld {
  font-size: 15px;
  font-family: "Poppins", sans-serif;
  border: 0px;
}
.tekstveld:hover {
  background-color: #ffdab5;
  cursor: pointer;
}
.tekstveld:focus {
  background-color: #ffdab5;
}

.aantekening {
  font-family: "Poppins", sans-serif;
  height: 170px;
  font-size: 16px;
  border-width: 0px;
  width: 100%;
  /* background-color: #E4ECFA; */
  /* padding: 14px; */
  /* border-radius: 5px; */
}
.aantekening:hover {
  background-color: #ffdab5;
  cursor: pointer;
}
.aantekening:focus {
  background-color: #ffdab5;
}
</style>
